import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PageNavComponent } from './page-nav.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
export { PageNavComponent };

export const MODULE_IMPORTS = [CommonModule];

export const MODULE_DECLARATIONS = [PageNavComponent];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: [MODULE_IMPORTS, MatSidenavModule, MatIconModule, MatButtonModule, TranslateModule],
  exports: [PageNavComponent],
})
export class GalaxyPageNavModule {}
